module.exports = __webpack_public_path__ + "static/united-states-b19143707825c64ab7164dc1296b6c07.svg";